// extracted by mini-css-extract-plugin
export default {"card":"styles_card__4wLeX","title":"styles_title__oqT25","subtitle":"styles_subtitle__-V+Mj","infoSpan":"styles_infoSpan__unm4o","cardBtn":"styles_cardBtn__wLUYl"};